import { gql } from "@apollo/client"
import styled from "@emotion/styled"
import { Button, Text, theme } from "@pallet-hq/hegel"
import { CenteredRow } from "components/atoms"
import CoverPhoto from "components/CoverPhoto"
import Image from "components/Image"
import LinkText from "components/Link/LinkText"
import { useCandidateApplication } from "@pallet/features/onboardingL2/useCandidateApplication"
import { WelcomeHeroSection_applylist } from "__generated__/WelcomeHeroSection_applylist"
import mixpanel from "mixpanel-browser"
import { EVENTS } from "constants/events"
import { usePalletContext } from "utils/hooks/usePalletContext"
import Tooltip from "components/Tooltip"

const HeroSectionFragment = gql`
    fragment WelcomeHeroSection_applylist on ApplylistType {
        id
        slug
        curatorName
        banner {
            source
        }
        curatorAvatar {
            source
        }
        group {
            id
            upsellTitle(useDefault: true)
            upsellSubtitle(useDefault: true)
        }
    }
`

type HeroSectionProps = {
    applylist: WelcomeHeroSection_applylist
}

const HeroSection = ({ applylist }: HeroSectionProps) => {
    const group = applylist.group!
    const palletContext = usePalletContext()
    const { showModal } = useCandidateApplication()

    return (
        <>
            <CoverPhoto
                containerHeight={["96px"]}
                colorSlug=""
                src={applylist.banner?.source}
            />
            <Wrapper>
                <CenteredRow>
                    <CuratorImage
                        width={24}
                        height={24}
                        borderRadius="100%"
                        src={applylist.curatorAvatar.source}
                        colorSlug=""
                    />
                    Curated by {applylist.curatorName}
                </CenteredRow>
                <Text variant="titleLarge" mt="small">
                    {group.upsellTitle}
                </Text>
                <Text variant="headlineMedium" color="gray600" mt="small">
                    {group.upsellSubtitle}
                </Text>
                <Button
                    disabled
                    size="large"
                    mt="large"
                    data-for="disabledTip"
                    data-tip="Pallet is no longer taking in new direct subscriptions. Check back later!"
                >
                    Meet candidates {"—>"}
                </Button>
                <Tooltip id="disabledTip" place="top" effect="solid"></Tooltip>
                <div>
                    <LinkText
                        onClick={() => {
                            mixpanel.track(EVENTS.COLLECTIVE_CLICK_APPLY, {
                                pallet: palletContext.pallet,
                            })
                            showModal()
                        }}
                        mt="small"
                        color={theme.colors.gray600}
                        disabled
                    >
                        I’m a candidate looking for work
                    </LinkText>
                </div>
                <Tooltip id="disabledTip" place="top" effect="solid"></Tooltip>
            </Wrapper>
        </>
    )
}

HeroSection.fragment = HeroSectionFragment
export default HeroSection

const CuratorImage = styled(Image)`
    object-fit: cover;
    margin-right: 8px;
`

const Wrapper = styled.section`
    max-width: 640px;
    text-align: center;
    margin: ${theme.space.large} auto;
    padding: 0 ${theme.space.small};
    box-sizing: border-box;
`
